<template>
  <div class="inquire_view"
       v-loading='fullscreenLoading'>
    <div class="inquire_view_top">
      <div class="inquire_view_top_info">
        <el-form :model="inqueryData"
                 ref="inqueryData"
                 label-width="100px"
                 size='small'
                 label-position="top"
                 class="demo-ruleForm">
          <el-form-item label='起运仓库'
                        class="ruleForm_item"
                        prop="wareHouseId">
            <el-select v-model="inqueryData.wareHouseId"
                       placeholder="请选择起运的仓库">
              <el-option v-for="item in wareHouse_optionsData"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label='目的国家'
                        class="ruleForm_item"
                        prop="siateId">
            <el-select v-model="inqueryData.siateId"
                       @change='getStateFba'
                       placeholder="请选择您寄往的国家">
              <el-option v-for="item in optionsData"
                         :key="item.id"
                         :label="item.zh"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label='FBA仓库代码'
                        class="ruleForm_item"
                        v-if="inqueryData.type!=2">
            <el-select v-model="inqueryData.fbacode"
                       filterable
                       :placeholder="fbaCode.length==0?'未选择或国家不支持FBA':'如果需要寄往FBA请选择'">
              <el-option v-for="item in fbaCode"
                         :key="item.id"
                         :label="item.code?item.code+' ( '+item.zipcode+' )':''"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
      <div class="inquire_view_top_goods"></div>
    </div>
    <div class="inquire_view_centent">

    </div>
  </div>
</template>

<script>
import { apiTypeSite, apiUserWarehouse, apiFba, apiLineList } from '@/request/api'
export default {
  name: 'inquire',
  data () {
    return {
      // ===================【 加载动画 】 ===================
      fullscreenLoading: false,
      // ===================【 仓库数据-包括集运和商业件 】 ===================
      wareHouseDate: {
        sy: [],
        jy: []
      },
      // ===================【 商业件的FBA数据 】 ===================
      fbaCode: [],
      // ===================【 国家数据-包括集运和商业件 】 ===================
      siteDate: {
        1: [],
        2: []
      },
      // ===================【 查询条件 】 ===================
      inqueryData: {
        type: 1,
      }
    }
  },
  methods: {
    // -------------------【 获取仓库数据 】 -------------------
    async getWarehouse () {
      this.fullscreenLoading = true
      this.wareHouseDate = {
        sy: [],
        jy: []
      }
      let res = await apiUserWarehouse()
      if (res.errno == 0) {
        res.cklist.forEach(e => {
          if (e.type == 1) {
            this.wareHouseDate.sy.push(e)
          } else if (e.type == 2) {
            this.wareHouseDate.jy.push(e)
          } else if (e.type == 3) {
            this.wareHouseDate.sy.push(e)
            this.wareHouseDate.jy.push(e)
          }
        });
      }

      this.fullscreenLoading = false
    },
    // -------------------【 获取国家数据 】 -------------------
    async getState () {
      this.fullscreenLoading = true
      let res = await apiTypeSite()
      if (res.errno == 0) {
        this.siteDate = res.gjlist
      }
      this.fullscreenLoading = false
    },
    // -------------------【 获取该国家的fba仓库 】 -------------------
    async getStateFba (e) {
      let res = await apiFba({
        pd: 'list',
        addrid: e,
      })
      if (res.errno == 0) {
        res.fbalist.unshift({
          address: "",
          addrid: "",
          city: "",
          code: "",
          id: "",
          province: "",
          uniacid: "",
          zipcode: ""
        })
        this.fbaCode = res.fbalist

      } else {
        this.fbaCode = []
      }
    },
  },
  computed: {
    // ===================【 根据运输类型切换仓库 】 ===================
    wareHouse_optionsData () {
      return this.inqueryData.type == 1 ? this.wareHouseDate.sy : this.wareHouseDate.jy
    },
    // ===================【 根据运输类型切换国家 】 ===================
    optionsData () {
      return this.inqueryData.type == 1 ? this.siteDate[1] : this.siteDate[2]
    }
  },
  created () {
    this.getState()
    this.getWarehouse()
  }
}
</script>

<style lang='scss'>
.inquire_view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .inquire_view_top {
    width: 100%;
    height: 0;
    max-height: 200px;
    background-color: #fff;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    .inquire_view_top_info {
      flex: 1;
      width: 100%;
      display: flex;
      .el-form {
        display: flex;
        width: 100%;
        .ruleForm_item {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          flex: 1;
          input {
            text-align: center;
          }
        }
      }
      .el-input {
        width: 200px;
      }
    }
    .inquire_view_top_goods {
      width: 100%;
      flex: 1;
    }
  }
  .inquire_view_centent {
    width: 100%;
    flex: 1;
    background-color: #f5f5f5;
  }
}
</style>